/**
 * @fileoverview Tradução com valores que vão como foram escritos, por fora da
 * interpolação do i18next. O i18next 19 interpola de novo o que entra: um nome
 * com "{{" ou "$t(", ou uma variável de template como "{{2}}", seria lida como
 * outra variável e sumiria. Cada valor entra como um marcador invisível,
 * trocado depois da tradução.
 *
 * Saiu do editor de lembretes da triagem (nomes de fila e de pessoa); também é
 * usada pelas abordagens inteligentes (variáveis {{N}} dos templates).
 */

import { i18n } from "../translate/i18n";

export const translateWithLiterals = (key, values) => {
  const names = Object.keys(values);
  let text = i18n.t(key, Object.fromEntries(names.map((name, i) => [name, `⁣${i}⁣`])));
  names.forEach((name, i) => {
    text = text.split(`⁣${i}⁣`).join(String(values[name] ?? ""));
  });
  return text;
};
